<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import ReportGenerateDialogHeader from '@/components/headers/ReportGenerateDialogHeader.vue';
import PageDialogWrapper from '@/components/wrappers/PageDialogWrapper.vue';

import dialog from '@/styles/jobEditDialog.module.scss';

export interface Props {
  isConfirmLoading?: boolean;
  confirm?: () => Promise<unknown>;
}
export type DefProps = typeof props;

const props = withDefaults(defineProps<Props>(), {
  isConfirmLoading: false,
  confirm: undefined,
});

const emit = defineEmits<{
  cancelBtnClick: [event: Event];
  confirmBtnClick: [event: Event, props: DefProps];
}>();

function handleCancelClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('cancelBtnClick', event);
}

function handleConfirmClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('confirmBtnClick', event, props);
}
</script>

<template>
  <PageDialogWrapper
    :class="[$style.jobEditUndoAllChangesDialog, dialog.dialogRoot]"
    data-testid="jobEditUndoAllChangesDialog"
  >
    <template #header>
      <ReportGenerateDialogHeader @close-click="handleCancelClick">
        Undo All Changes
      </ReportGenerateDialogHeader>
    </template>

    <section>
      <div :class="dialog.text">
        Are you sure you want to undo all recent changes for this job?
      </div>
    </section>

    <template #footer>
      <menu :class="dialog.dialogFooterMenuList">
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn
            variant="outlined"
            append-icon="mdi-close"
            :disabled="props.isConfirmLoading"
            @click="handleCancelClick"
          >
            Cancel
          </KBtn>
        </li>
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn
            append-icon="mdi-undo-variant"
            color="error"
            :loading="props.isConfirmLoading"
            @click="handleConfirmClick"
          >
            Undo All
          </KBtn>
        </li>
      </menu>
    </template>
  </PageDialogWrapper>
</template>

<style module lang="scss">
@use '@/styles/variables';

.jobEditUndoAllChangesDialog {
  width: variables.$reportGenerateDialogWidth;
}
</style>
